export const frameReviewRequestDetails = (res) => {
    return {
        requestedDate: res.requested_date,
        email: res.details.email,
        role: res.details.custom_Groups,
        email_id: res.email_id
    }
}


export const frameRejectedHistory = (res) => {
    return {
        email: res.email_id,
        rejected_date: res.rejected_date,
        company: res.custom_company
    }
}
